module.exports = "/_next/static/images/VGBExampleImage1-d2bda2167905880724cc29246a9bd7c5.png";